var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-content"},[_c('div',{staticClass:"header"},[_c('home-header')],1),_c('div',{staticClass:"leaderboard"},[_c('leader-board')],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }